import moment from 'moment-timezone';
import { createAction } from 'redux-act';

import { SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import TimestampPayload from '../TimestampPayload';
import ReservationPayload from './ReservationPayload';

export interface UpdateReservationStatePayload extends ReservationPayload {
  reservation: SeatedReservation;
  newState: string;
  datetime: moment.Moment;
}
export const updateReservationState = createAction<UpdateReservationStatePayload>('UPDATE_RESERVATION_STATE');

export interface ReservationStateUpdatedPayload extends TimestampPayload, ReservationPayload {
  reservation: SeatedReservation;
}
export const reservationStateUpdated = createAction<ReservationStateUpdatedPayload>('RESERVATION_STATE_UPDATED');

export type ReservationStateUpdateFailedPayload = TimestampPayload & ReservationPayload;
const stateUpdateFailed = 'RESERVATION_STATE_UPDATE_FAILED';
export const reservationStateUpdateFailed = createAction<ReservationStateUpdateFailedPayload>(stateUpdateFailed);
